import { ReactNode } from 'react'
import { MainColumn } from './components/MainColumn'

export const SingleColumn = ({children}: {children: ReactNode}) => (
  <MainColumn>
    {children}
  </MainColumn>
)
